import EfSection from 'elem/ui/ef-section';
import EfSpec from 'elem/ui/ef-spec';
import { useRouter } from 'next/router';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale = 'us' } = useRouter();

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-m" />
            <EfSection title={t('NA3_title')} desc={t('NA3_desc')} theme="white" />
            <EcoImg
                pc="https://websiteoss.ecoflow.com/upload/image/1751011033783/h.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1751011033783/h.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1751011033670/h-m.jpg"
            />
            <EfSpec className="spec-x" />
        </div>
    );
}
